import "./CharacterComponent.css"
export function CharacterComponent({character}){
    return(
        <div className="character-card">
            <h1 className="character-title">{character.name}</h1>
            <div className="character-description">
                <div>
                    <p>{character.race}</p>
                    <p>KI: {character.maxKi}</p>
                </div>  
                <img className="character-img" src={character.image} alt="Character img"></img>
            </div>
        </div>
    )
}